import SmarttenderApi from '@/api/smarttenderApi'
const tender_api = new SmarttenderApi()

import StageAgreementsApi from '@/api/stageAgreementsApi'
const stageAgreements_api = new StageAgreementsApi()


import Vue from 'vue'
import moment from 'moment'
import router from '../../router'
import { i18n } from 'plugins/i18n'
import { getMinProposalsDate } from '@/plugins/tenderDates.js'

const pendingNbuRates = {}

export default {
  async tendersSearch(context, payload) {
    return await tender_api.tendersSearch(payload)
  },

  async tendersStatistic(context, payload) {
    return await tender_api.tendersStatistic(payload)
  },

  async setAllBiddingTypes(context, payload) {
    let biddingTypes = context.getters.getBiddingAllTypes

    if (!biddingTypes?.length || biddingTypes.length == 1 || payload) {
      this.$store.dispatch('setBiddingTypes')
        .then(() => {
          return context.getters.getBiddingAllTypes
        })
    } else {
      return biddingTypes
    }
  },
  async setBiddingTypes(context, payload) {
    let biddingTypes = context.getters.getBiddingTypes
    if (!biddingTypes?.length || biddingTypes.length == 1 || payload) {
      return await tender_api.biddingTypes(payload?.org)
        .then((response) => {
          biddingTypes = response?.data?.biddingTypes?.sort((a,b) => a.titleRu?.localeCompare(b.titleRu))
          if (!biddingTypes?.length) {
            Vue.prototype.$notice.warning({
              title: 'Помилка',
              message: 'Помилка отримання <b>типів торгів</b>',
              dangerouslyUseHTMLString: true,
              duration: 10,
              loading: false,
              showClose: true,
              closeText: 'Закрити',
            })
            return []
          }
          if (!payload?.org) {
            context.commit('setBiddingTypes', biddingTypes)
          }
          return biddingTypes?.filter(i => i.allowCreation)
        })
    } else {
      return biddingTypes
    }
  },
  async setSupplierAddress(context, payload) {
    let supplierAddress = context.getters.getSupplierAddress
    if (!supplierAddress?.length || payload) {
      return await tender_api.supplierAddress().then(res => {
        let adr =  res?.data?.supplierAddress
        context.commit('setSupplierAddress', adr)
        return adr
      })
    } else {
      return supplierAddress
    }
  },
  async setAvailableCards(context, payload) {
    let availableCards = context.getters.getAvailableCards,
      item = availableCards.find(el => el.id == payload)
    if (!availableCards?.length || !item) {
      return await tender_api.availableCards(payload).then(res => {
        // context.commit('setAvailableCards', {items: res?.data?.bindedCards, id: payload })
        return res?.data?.bindedCards
      })
    } else {
      return item.items
    }
  },
  async infoAboutCriterionCard(context, payload) {
    let result, id = payload.hasOwnProperty('id') ? payload?.id : payload
    if (!Vue.prototype.$ability.can('use', 'useCriteriaCards') || !id) {
      return
    }

    if (payload.save) {
      result = context.getters.getCriteriaCardById(id)
      if (!result) {
        result = await tender_api.infoAboutCriterionCard(id)
        context.commit('setCriterionCardId', result)
      }
    } else {
      result = await tender_api.infoAboutCriterionCard(id)
    }

    if (!result) {
      return result
    }

    result.title = result?.criterionCardType === 'STANDARD' ? i18n.messages[i18n.locale].Tenders.StandardSetCriteria : result?.title

    return result
  },
  async setAccreditedSuppliers(context, payload) {
    let accreditedSuppliers = context.getters.accreditedSuppliers
    if (!accreditedSuppliers?.length || payload) {
      return await tender_api.accreditedSuppliers()
    } else {
      return accreditedSuppliers
    }
  },
  async setProlongationRule(context, payload) {
    let prolongationRule = context.getters.getProlongationRule
    if (!prolongationRule?.length || payload) {
      return await tender_api.prolongationRule()
        .then((response) => {
          let prolongationRule = response?.data?.prolongationRule
          context.commit('setProlongationRule', prolongationRule)
          return prolongationRule
        })
    } else {
      return prolongationRule
    }
  },

  async getTenderItem(context, {id, condition = false}) {
    if (!id) {
      return
    }
    let item = context.getters.getTender
    if (!item || !item.lots || item.tenderId != id || condition) {
      await tender_api.getTender(id)
        .then(res => {
          if (!res) {
            router.push({name: 'page-error', params: { status_code: 404, descript: 'tenderActions'}})
          }
          item = res
        })
        .catch(res => Vue.prototype.$log_error(res))
    }
    return item
  },
  async getEditingTender(context, id) {
    let item
    await tender_api.getEditingTender(id)
      .then(res => {
        // С бека лоты приходят не отсортированными. Приводим в порядок
        if (res?.data?.editingTender?.length) {
          res.data.editingTender.lots = res.data.editingTender.lots.sort((a, b) => a.lotNumber - b.lotNumber)
        }
        item = res?.data?.editingTender
        // if(item.tenderPeriodTo < moment().add(2, 'days').format() || moment().add(2, 'days').isoWeekday() >= 5
        //   || item.tenderPeriodTo < moment().add(3, 'days').format() || moment().add(3, 'days').isoWeekday() >= 5) {
        //   Vue.prototype.$set(item, 'tenderPeriodTo', null)
        // }
        if (!item) {
          Vue.prototype.$log_error(`Ошибка получения тендера. ID:${id}`)
        } else {
          item.biddingTypeId = item?.biddingType?.biddingTypeId
        }
        Vue.prototype.$store.commit('setNewTender', item)
      })
      .catch(res => Vue.prototype.$log_error(res))
    return item
  },
  async setCurrencies(context, payload = '') {
    let currencies = context.getters.getCurrencies
    if (!currencies?.length || currencies.length == 1 || payload) {
      return await tender_api.currencies()
        .then(response => {
          let items = response?.data?.currencies
          context.commit('setCurrencies', items)
          return items
        })
        .catch(response => {
          let items = response?.data?.currencies
          items ? context.commit('setCurrencies', items) : ''
          return items
        })
    } else {
      return currencies
    }
  },

  async setTenderMeasurements(context, payload = '') {
    let measurements = context.getters.getMesurementUnit
    if (!measurements?.length || measurements.length == 1 || payload) {
      return await tender_api.availableUnits()
        .then(response => {
          let items = response
          context.commit('setMesurementUnit', items)
          return items
        })
    } else {
      return measurements
    }
  },

  async setTopMeasurements(context, payload = '') {
    let topMeasurements = context.getters.setTopMesurementUnit
    if (!topMeasurements?.length || topMeasurements.length == 1 || payload) {
      return await tender_api.topOrganizationUnits(5).then((result) => {
        context.commit('setTopMesurementUnit', result)
        return result
      })
    } else {
      return topMeasurements
    }
  },

  async setSubcategory(context, payload) {
    let subcategories = context.getters.getSubcategories,
      category = subcategories.find(cat => cat.classificationCode == payload)
    if (!subcategories?.length || !category) {
      return await tender_api.subcategories(payload)
        .then(response => {
          let items = response
          context.commit('setSubcategories', items)
          return items
        })
    } else {
      return [category]
    }
  },

  async setResourcesItems(context, payload) {
    // let resources = context.getters.getResourcesItems
    // if(!resources?.hasOwnProperty(payload)) {
    return await(tender_api.resources(payload)
      .then(response => {
        let items = response
        context.commit('setResourcesItems', { category: payload, items: items })
        return items
      }))
    // } else {
    //   return resources[payload]
    // }
  },

  async subscribedUsers(context, payload) {
    const result = await tender_api.subscibedUsers(payload.tenderId, payload.classificationCode)
    if (!result?.length) {
      return []
    }
    result.forEach(resultItem => {
      if (resultItem?.users?.length) {
        resultItem.users = resultItem.users
          .map(i => ({
            ...i,
            selected: false,
            expanded: false,
            organizationId: resultItem.organizationId,
            organizationUsreou: resultItem.organizationUsreou,
          }))
          .sort((a,b) => b.participationCount - a.participationCount || a.name?.localeCompare(b.name))
      }
    })

    return result
      .map(i => ({
        ...i,
        selected: false,
        expanded: false,
      }))
      .sort((a,b) => b.participationCount - a.participationCount)
  },

  /* async setAllTenderStatuses(context, payload) {
    let tenderStatuses = context.getters.getTenderAllStatuses

    if(!tenderStatuses?.length || tenderStatuses.length == 1 || payload) {
      this.$store.dispatch('setTenderStatuses')
        .then(() => {
          return context.getters.getTenderAllStatuses
        })
    } else {
      return tenderStatuses
    }
  },*/
  async setTenderStatuses(context, payload = '') {
    let tenderStatuses  = context.state.tenderStatuses
    if (!context.state.stateLoading.status) {
      context.state.stateLoading.status = true
      if (!tenderStatuses?.length || tenderStatuses.length == 1 || payload) {
        return await tender_api.getTenderStatuses()
          .then(response => {
            context.state.stateLoading.status = false
            context.commit('setTenderStatuses', response)
            return response?.filter(i => i.isUsed)
          })
      } else {
        return tenderStatuses
      }
    } else {
      return tenderStatuses
    }
  },

  async setDepartments(context, payload) {
    let departments  = context.getters.getDepartments

    if (!departments?.length) {
      return await tender_api.getDepartments(payload)
        .then(response => {
          context.commit('setDepartmentsToState', response)
          return response
        })
    } else {
      return departments
    }
  },
  setNbuCurrencyRate(context, currencyId) {
    let nbuCurrencyRate  = context.getters.getNbuCurrencyRate

    currencyId = currencyId || 980

    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }

    const current = nbuCurrencyRate?.[currencyId] || {}

    if (!current.nbuId) {
      if (currencyId === 980) {
        const response = {
          nbuId: 980,
          title: 'Грн',
          rate: 1,
          symbol: 'UAH',
          exchangeDate: options,
        }

        context.commit('setNbuCurrencyRateToState', response)
        return Promise.resolve(response)
      }
      if (pendingNbuRates[currencyId]) {
        return pendingNbuRates[currencyId]
      }
      pendingNbuRates[currencyId] = tender_api.getNbuCurrencyRate(currencyId)
        .then(response => {
          if (response) {
            context.commit('setNbuCurrencyRateToState', response)
          }
          return response
        })
        .finally(() => {
          delete pendingNbuRates[currencyId]
        })
      return pendingNbuRates[currencyId]
    } else {
      return Promise.resolve(current)
    }
  },
  async setTendersSettings({commit}, payload) {
    if (!payload) {
      return await tender_api.getTendersSettings()
        .then(response => {
          let settings = response
          commit('setTendersSettings', settings)
          return settings
        })
    }
  },

  async treeView(context, payload = '') {
    let treeView  = context.getters.getTreeView
    if (!treeView?.length || treeView.length == 1 || payload) {
      return await tender_api.treeView()
        .then(response => {
          treeView = response
          return treeView
        })
    } else {
      return treeView
    }
  },

  setMinPproposalsDate(context/*, payload*/) {
    let rule = Vue.prototype.$ability.g?.daysWebTender?.set_minimal
    let min_time = ('' + ((rule ? Object.values(rule)[0].conditions : 0)))
    let minEndTimeTender = moment(getMinProposalsDate(min_time))

    context.commit('setMinPproposalsDate', minEndTimeTender)

    /*let available_days = context.getters.getHolidays
    minEndTimeTender = moment(payload || undefined).add(min_time, 's')
    let accuum = 0

    while (moment(minEndTimeTender).isoWeekday() > 5) {
      minEndTimeTender.add(1, 'd')
    }
    minEndTimeTender = moment(moment(minEndTimeTender)?.format('YYYY-MM-DDTHH:mm')).add(1, 'm')
    let time = moment(minEndTimeTender).format('HH.mm')
    if (time > '18.00' || time < '08.00') {
      if (time > '18.00') {
        minEndTimeTender = moment(minEndTimeTender).add(1, 'd')
      }
      minEndTimeTender = moment(minEndTimeTender).set('hour', '08')
      minEndTimeTender = moment(minEndTimeTender).set('minute', '00')
    }
    // + після додавання годин бо можуть додатись до вихідного
    if (available_days?.length) {
      while (available_days?.find(date => {
        return moment(date.date).format('YYYY-MM-DD') == moment(minEndTimeTender).format('YYYY-MM-DD')
      })?.dayType != 'WORK_DAY'  && accuum < 5) {
        minEndTimeTender.add(1, 'd')
        ++accuum
      }
    }
    context.commit('setMinPproposalsDate', minEndTimeTender) // todo from 8.00
    */
  },

  async getHolidays(context, payload) {
    let holidays  = context.getters.getHolidays
    let from = moment(payload.from || payload).startOf('month').format('YYYY-MM-DD') ,
      to = moment(payload.to || payload).endOf('month').format('YYYY-MM-DD')

    if (holidays.some(day => {
      return moment(day.date).format('YYYY-MM') == moment(to).format('YYYY-MM')
          || moment(day.date).format('YYYY-MM') == moment(from).format('YYYY-MM')
    })) {
      return
    }
    await tender_api.getHolidays(from, to)
      .then(response => {
        context.commit('setHolidays', response)
      })
  },

  async tenderContactPersons(context) {
    let people  = context.getters.getTenderContactPersons
    if (!people?.length) {
      return await tender_api.tenderContactPersons()
    } else {
      return people
    }

  },

  async historyLots(context, payload) {
    return await tender_api.historyLots(payload)
  },
  async historyBidders(context, payload) {
    return await tender_api.historyBidders(payload)
  },
  async prequalification(context, payload) {
    return await tender_api.prequalification(payload)
  },
  async getTenderBidHistory(context, payload) {
    return await tender_api.getTenderBidHistory(payload)
  },
  async tendersAgreements(context, payload) {
    return await tender_api.tendersAgreements(payload)
  },
  async tenderAgreeHistory(context, payload) {
    return await tender_api.tenderAgreeHistory(payload)
  },
  async agreeLatest(context, payload) {
    return await stageAgreements_api.agreeLatest(payload)
  },
  async actualAgreementsByTenders(context, payload) {
    return await stageAgreements_api.actualAgreementsByTenders(payload)
  },
  async tenderStageAgreeHistory(context, payload) {
    return await stageAgreements_api.agreeHistory(payload)
  },
  async tenderUserAgree(context, payload) {
    return await tender_api.tenderUserAgree(payload)
  },
  async startTenderAgree(context, payload) {
    return await tender_api.startTenderAgree(payload)
  },
  async getForm(context, payload) {
    return await tender_api.getForm(payload)
  },
  async getCriteriaCardTemplates(context, payload = '') {
    let criteria_card_templates  = context.getters.getCriteriaCardTemplates
    if (!criteria_card_templates?.length || payload) {
      return await tender_api.getCriteriaCardTemplates()
        .then(response => {
          criteria_card_templates = response
          context.commit('setCriteriaCardTemplates', criteria_card_templates)
          return criteria_card_templates
        })
    } else {
      return criteria_card_templates
    }
  },

  async getFiltersTemplatesByType(context, payload = '') {
    let filters_templates  = context.getters.getFiltersTemplatesByType[payload]
    if (!filters_templates?.length) { // todo по типу посортувати + обробити iмітацію
      return await tender_api.getFiltersTemplatesByType(payload)
        .then(response => {
          filters_templates = response.map(i => ({
            ...i,
            filterObject: i?.filterJson ? JSON.parse(i.filterJson) : {}
          }))
          context.commit('setFiltersTemplatesByType', {items: filters_templates, name: payload})
          return filters_templates
        })
    } else {
      return filters_templates
    }
  },
  async addFilterTemplates(context, payload) {
    return await tender_api.addFilterTemplates(payload)
      .then(response => {
        if (!response) {
          throw Vue.prototype.$t('Errors.STHWrong')
        }
        context.commit('addFilterTemplate', response)
        return response
      })
  },
  async editFilterTemplate(context, payload) {
    return await tender_api.editFilterTemplate(payload)
      .then(response => {
        if (!response) {
          throw Vue.prototype.$t('Errors.STHWrong')
        }
        context.commit('editFiltersTemplate', payload)
        return response
      })
  },
  async deleteFilterTemplate(context, payload) {
    return await tender_api.deleteFilterTemplate(payload.id)
      .then(response => {
        if (!response) {
          throw Vue.prototype.$t('Errors.STHWrong')
        }
        context.commit('deleteFilterTemplate', payload)
        return response
      })
  },
  async personalManagers(context, payload = '') {
    let personalManagers  = context.getters.personalManagers
    if (!personalManagers?.length || payload) {
      return await tender_api.personalManagers()
        .then(response => {
          personalManagers = response
          context.commit('setPersonalManagers', personalManagers)
          return personalManagers
        })
    } else {
      return personalManagers
    }
  },
}
